/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TaskInsertNew/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Actions from './Actions/index'
import Assignee from './Assignee/index'
import Board from './Board/index'
import Description from './Description/index'
import DueDate from './DueDate/index'
import Priority from './Priority/index'
import React from 'react'
import Stage from './Stage/index'
import Tags from './Tags/index'
import Title from './Title/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TaskInsertNew({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let eventActionDataBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.board_id',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 weight="medium"
 text="Details"
/>
<div
  data-testid="TaskInsertNew.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z2jrqSO': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-2-Z2jrqSO': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TaskInsertNew.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
<div
  data-testid="TaskInsertNew.Vertical:1"
  data-view-path={viewPath}
 style={{'--blc-3-Z2jrqSO': dtColorsNeutral200,'--pl-4-Z2jrqSO': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-2-Z2jrqSO': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="TaskInsertNew.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="TaskInsertNew.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Board"
/>
</div>
<Board
  viewPath={`${viewPath}/Board`}
/>
</div>
<fromFlow.When is={eventActionDataBoardIdValueData}>
<div
  data-testid="TaskInsertNew.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<div
  data-testid="TaskInsertNew.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Stage"
/>
</div>
<Stage
  viewPath={`${viewPath}/Stage`}
/>
</div>
</fromFlow.When>
<div
  data-testid="TaskInsertNew.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<div
  data-testid="TaskInsertNew.Horizontal:6"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal6}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Assignee"
/>
</div>
<Assignee
  viewPath={`${viewPath}/Assignee`}
/>
</div>
<div
  data-testid="TaskInsertNew.Horizontal:7"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal7}`}
>
<div
  data-testid="TaskInsertNew.Horizontal:8"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal8}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Priority"
/>
</div>
<Priority
  viewPath={`${viewPath}/Priority`}
/>
</div>
<div
  data-testid="TaskInsertNew.Horizontal:9"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal9}`}
>
<div
  data-testid="TaskInsertNew.Horizontal:10"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal10}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Add tags"
/>
</div>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
</div>
<div
  data-testid="TaskInsertNew.Horizontal:11"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal11}`}
>
<div
  data-testid="TaskInsertNew.Horizontal:12"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal12}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Due date"
/>
</div>
<DueDate
  viewPath={`${viewPath}/DueDate`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}